(ns teamoesterreich.admin-mode.lebensretter.detail.lna-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            ))

(defn form [!lna lnaActive]
  [mui/box {:sx {:display "grid" :gridTemplateColumns "1fr 1fr" :gap "1rem"}}
   [:h3 {:style {:grid-column "span 2"}} "LNA-Einsätze"]
   [mui/form-control-label
    {
     :style   {:background-color (if (not= lnaActive @!lna) "#ffd6d2" "transparent")
               :grid-column      "span 2"}
     :label   "Berechtigt (österreichweit)"
     :control (r/as-element
                [mui/checkbox {:color    "primary"
                               :checked  (or @!lna false)
                               :onChange (fn [_ val]
                                           (reset! !lna val))
                               }])
     }
    ]
   ])

